import "./lib/sentry";
import { createRoot } from "react-dom/client";
import { Sentry, isSentryEnabled } from "./lib/sentry";
import App from "./App";
import { ErrorFallback } from "./components/ErrorFallback";
import "./index.css";

const root = createRoot(document.getElementById("root")!);

if (isSentryEnabled) {
  root.render(
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>,
  );
} else {
  root.render(<App />);
}
